<!-- 我的 -->

<template>
  <div class="learingTikuSpecial">
    <backHeader back-addr="/indexKaoyan"></backHeader>
                <div id="tiku_special">
                    <div style="height:15px;"></div>
                    <div style="background-color:white;margin-left:9px;margin-right:9px;margin-bottom:12px;height:44px;line-height:44px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;" v-for="tikuSpecial in tikuSpecials">
                        <div style="display:flex;" @click="go(tikuSpecial.multipleSelection,tikuSpecial.name)">
                            <p style="color:#8f8f94;flex:3;margin-bottom:0px;margin-left:15px;">{{ tikuSpecial.name }}</p>
                            <!-- <img :src="tikutype.imgurl" style="position:absolute;right:10px;top:6px;" /> -->
                            <span class="" style="color:red;flex:1;font-size:14px;line-height:44px;vertical-align:center;height:44px;text-align:right;margin-right:20px;">{{tikuSpecial.multipleSelection.length}}</span>
                        </div>
                    </div>
                    <div style="height:60px;"></div>
                </div>
  </div>
  
</template>

<script>
import axios from "axios";
import Qs from "qs";
import Addr from "./../utils/getAPI";
import store from "@/store/index";
import { Toast } from "mint-ui";
import crossLine from "./../components/cross-line.vue";
import backHeader from "./../components/back-header.vue";

export default {
  components: {
    crossLine,
    backHeader
  },
  data() {
    return {
      tikuSpecials:[]
    };
  },
  props: {},
  watch: {},
  methods: {
    initTikuSpecialData() {
      axios
        .get(Addr.getGoNewAPIPrefix() + "tiku/listTikuSpecial?pageNum=1&pageRow=1000")
        .then(res => {
          console.log("res is:");
          console.log(res);
          if (res.data.returnCode == 100) {
            //初始化赋值题目列表，以及题目总数，还有随机抽取出第一道题目
            this.tikuSpecials = res.data.returnData.list;
            console.log("this tikuSpecials is:",this.tikuSpecials);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    go(multipleSelection,name){
      //设置选中的题目
      this.$store.commit("updateMultipleSelection", multipleSelection);
      this.$router.push({
        path: "/tikuSpecialList",
        query: {
          specialName:name,
          //multipleSelection: multipleSelection
        }
      });
    }
  },
  filters: {},
  computed: {},
  created() {
    this.initTikuSpecialData();
  },
  mounted() {},
  destroyed() {}
};
</script>

<style lang="scss" scoped>

.learingTikuSpecial {
  width: 100%;
  height: 100%;
  background-color: #ebebeb;
}

.tiku_special {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/module-tiku/tikuSpecial.vue